import React, { Component } from 'react';
import { Button, Modal, Row, Col, Form } from 'react-bootstrap';
import { store } from 'react-notifications-component';
import { commonServices } from '../../../app/commonServices/commonServices';
import { Formik } from 'formik';
// import * as Yup from 'yup'; // for everything
// import * as constants from '../../constants';
// var mime = require('mime-types')
import mime from 'mime-types';
import * as firebase from 'firebase/app';

// const addPhotosSchema = Yup.object().shape({
//     file: Yup
//         .array()
//         .required("A file is required")
//         // .test(
//         //     "fileSize",
//         //     "File too large",
//         //     value => value && value.size <= FILE_SIZE
//         // )
//         .test(
//             "fileFormat",
//             "Please upload one of these extensions: .jpg, .jpeg, .gif or .png",
//             value => value && constants.SUPPORTED_IMAGE_FORMATS.includes(value.type)
//         )
// });

// const addVideosSchema = Yup.object().shape({
//     file: Yup
//         .array()
//         .required("A file is required")
//         // .test(
//         //     "fileSize",
//         //     "File too large",
//         //     value => value && value.size <= FILE_SIZE
//         // )
//         .test(
//             "fileFormat",
//             "Unsupported Format. Please upload one of these extensions: .mp4, .mov, .wmv, .flv or .mkv",
//             value => value && constants.SUPPORTED_VIDEO_FORMATS.includes(value.type)
//         )
// });

class PhotoGridComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ...props,
            showAddPhotosModal: false,
            showDeletePhotoModal: false
        }
    }

    static getDerivedStateFromProps(props, state) {
        let result = {}
        if (props.medias && props.medias.length) {
            result.medias = props.medias
        }
        return Object.keys(result).length > 0 ? result : null;
    }

    handleDeletePhotoButtonClick = async (id = null) => {
        if (id !== null) {
            await this.setState({ photoIdToBeDeleted: id })
        }
        await this.setState(state => ({ showDeletePhotoModal: !state.showDeletePhotoModal }));
    }

    handleApproveDeletePhotoButtonClick = async () => {
        if (this.state.photoIdToBeDeleted) {
            const result = await commonServices.deleteFile(this.state.photoIdToBeDeleted);
            if (result && result.status === 200) {
                //   ----------- USE CALLBACK  -----------------------
                // this.getInspectionReportById(this.state.workId);
                if (this.state.serviceRequestId) {
                    await this.state.photoGridComponentParentCallback(this.state.serviceRequestId);
                } else {
                    await this.state.photoGridComponentParentCallback(true);
                }
            }
        }
        await this.setState(state => ({ showDeletePhotoModal: !state.showDeletePhotoModal }));
    }

    handleAddPhotosButtonClick = async (sectionItemId = null, isSectionId = false, isVideo) => {
        this.setState(state => ({ showAddPhotosModal: !state.showAddPhotosModal, isVideo: isVideo }));
    }

    render() {
        const { medias, mode, serviceRequestId, reportSectionId, reportItemId, title,
            identifier, isVideo, isItemMedia, disabled, isPublished
        } = this.state;
        // section.collatedReportSectionFiles = medias
        //  mode = mode
        let containsVideos = false;
        medias && (medias.length > 0) && medias.forEach(image => {
            if (mime.lookup(image.url) && mime.lookup(image.url).startsWith('video')) {
                containsVideos = true
            }
        });

        const parentId = serviceRequestId || reportSectionId || reportItemId || undefined;
        return (
            <>
                {(((medias && medias.length === 0 && (mode === 'edit' || !mode))) || (medias && medias.length > 0)) &&
                    <h6 className=""><strong>{title}</strong></h6>
                }

                <div className="d-flex flex-wrap align-items-start">
                    {medias &&
                        medias.length > 0 &&
                        medias.map((media) => {
                            const isImage = mime.lookup(media.url)?.startsWith("image");
                            const isVideo = mime.lookup(media.url)?.startsWith("video");

                            return (
                                <div
                                    key={media.id}
                                    style={{
                                        width: "88px",
                                        height: "128px",
                                        marginRight: "16px",
                                        marginBottom: "16px",
                                        borderRadius: "16px",
                                        overflow: "hidden",
                                        background: "#fff",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                        border: "1px solid #ECECEC",
                                        position: "relative"
                                    }}
                                >
                                    {isImage && (
                                        <img
                                            src={media.url}
                                            alt=""
                                            title="Right-click & View Image"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover"
                                            }}
                                        />
                                    )}

                                    {containsVideos && isVideo && (
                                        <video
                                            controls
                                            title="Right-click & View Video"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover"
                                            }}
                                        >
                                            <source
                                                src={media.url}
                                                type={mime.lookup(media.url)}
                                            />
                                            Your browser does not support the video tag.
                                        </video>
                                    )}

                                    {/* Delete Button */}
                                    {(mode === "edit" || !mode) && !isPublished && (
                                        <button
                                            type="button"
                                            onClick={() =>
                                                this.handleDeletePhotoButtonClick(media.id)
                                            }
                                            style={{
                                                position: "absolute",
                                                top: "4px",
                                                right: "4px",
                                                width: "16px",
                                                height: "16px",
                                                borderRadius: "50%",
                                                border: "none",
                                                background: "#FF4D4F",
                                                color: "#fff",
                                                fontSize: "12px",
                                                fontWeight: 700,
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                zIndex: 10
                                            }}
                                        >
                                            ×
                                        </button>
                                    )}

                                    {/* Badge */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            left: "6px",
                                            bottom: "6px",
                                            background: "#6C63FF",
                                            color: "#fff",
                                            fontSize: "8px",
                                            fontWeight: 600,
                                            padding: "3px 6px",
                                            borderRadius: "20px",
                                            textTransform: "uppercase"
                                        }}
                                    >
                                        {isImage ? "PHOTO" : "VIDEO"}
                                    </div>
                                </div>
                            );
                        })}

                    {/* Add Photo */}
                    {(mode === "edit" || !mode) &&
                        !disabled &&
                        !isPublished && (
                            <div
                                onClick={() =>
                                    this.handleAddPhotosButtonClick(parentId, true)
                                }
                                style={{
                                    width: "88px",
                                    height: "128px",
                                    border: "2px dashed #7EA7FF",
                                    borderRadius: "16px",
                                    cursor: "pointer",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: "16px",
                                    marginBottom: "16px",
                                    background: "#FAFCFF"
                                }}
                            >
                                <div
                                    style={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "50%",
                                        background: "#EAF2FF",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        position: "relative"
                                    }}
                                >
                                    <i
                                        className="flaticon2-photo-camera"
                                        style={{
                                            fontSize: "16px",
                                            color: "#4A7CFF"
                                        }}
                                    />

                                    <div
                                        style={{
                                            position: "absolute",
                                            bottom: "-2px",
                                            right: "-2px",
                                            width: "14px",
                                            height: "14px",
                                            borderRadius: "50%",
                                            background: "#4A7CFF",
                                            color: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "10px",
                                            fontWeight: 700
                                        }}
                                    >
                                        +
                                    </div>
                                </div>

                                <div
                                    style={{
                                        marginTop: "12px",
                                        fontWeight: 600,
                                        fontSize: "10px",
                                        color: "#2c2c2c"
                                    }}
                                >
                                    Add Photo
                                </div>

                                <div
                                    style={{
                                        marginTop: "4px",
                                        fontSize: "8px",
                                        color: "#8c8c8c",
                                        textAlign: "center",
                                        lineHeight: "12px"
                                    }}
                                >
                                    Upload
                                    <br />
                                    device
                                </div>
                            </div>
                        )}

                    {/* Add Video */}
                    {(mode === "edit" || !mode) &&
                        !disabled &&
                        !isPublished && (
                            <div
                                onClick={() =>
                                    this.handleAddPhotosButtonClick(
                                        parentId,
                                        true,
                                        "yes"
                                    )
                                }
                                style={{
                                    width: "88px",
                                    height: "128px",
                                    border: "2px dashed #9ED6A7",
                                    borderRadius: "16px",
                                    cursor: "pointer",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "16px",
                                    background: "#FBFFFB"
                                }}
                            >
                                <div
                                    style={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "50%",
                                        background: "#EAF8EC",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        position: "relative"
                                    }}
                                >
                                    {/* <i
                                        className="flaticon2-video-camera"
                                        style={{
                                            fontSize: "16px",
                                            color: "#34A853"
                                        }}
                                    /> */}

                                    <div
                                        style={{
                                            fontSize: "16px",
                                            color: "#34A853"
                                        }}
                                    >
                                        🎥
                                    </div>



                                    <div
                                        style={{
                                            position: "absolute",
                                            bottom: "-2px",
                                            right: "-2px",
                                            width: "14px",
                                            height: "14px",
                                            borderRadius: "50%",
                                            background: "#34A853",
                                            color: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "10px",
                                            fontWeight: 700
                                        }}
                                    >
                                        +
                                    </div>
                                </div>

                                <div
                                    style={{
                                        marginTop: "12px",
                                        fontWeight: 600,
                                        fontSize: "10px",
                                        color: "#2c2c2c"
                                    }}
                                >
                                    Add Video
                                </div>

                                <div
                                    style={{
                                        marginTop: "4px",
                                        fontSize: "8px",
                                        color: "#8c8c8c",
                                        textAlign: "center",
                                        lineHeight: "12px"
                                    }}
                                >
                                    Upload
                                    <br />
                                    device
                                </div>
                            </div>
                        )}
                </div>

                {(mode === 'edit' || !mode) &&
                    <Modal backdrop="static" keyboard={false} key={'m' + 1} show={this.state.showAddPhotosModal} onHide={this.handleAddPhotosButtonClick} >
                        <Modal.Header closeButton>
                            <Modal.Title>{!isVideo ? `Add Photo` : `Add Video`}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Formik
                                initialValues={{
                                    reportItemId: reportItemId || undefined,
                                    reportSectionId: reportSectionId || undefined,
                                    serviceRequestacessId: serviceRequestId || undefined,
                                    file: undefined,
                                    identifier: identifier || undefined
                                }}
                                // validationSchema={!isVideo ? addPhotosSchema : addVideosSchema}
                                onSubmit={
                                    async (values, { setSubmitting }) => {
                                        let formData = new FormData();
                                        values.file && (values.file).forEach((file, index) => {
                                            reportItemId && formData.append(`files[${index}][reportItemId]`, reportItemId);
                                            reportSectionId && formData.append(`files[${index}][reportSectionId]`, reportSectionId);
                                            serviceRequestId && formData.append(`files[${index}][serviceRequestId]`, serviceRequestId);
                                            formData.append(`files[${index}][doc]`, values.file[index]);
                                            values.identifier && formData.append(`files[${index}][identifier]`, values.identifier);
                                        });
                                        const result = await commonServices.uploadFiles(formData);
                                        if (result && result.status === 201) {
                                            store.addNotification({
                                                title: "Success!",
                                                message: `Media added!`,
                                                type: "success",
                                                insert: "top",
                                                container: "top-right",
                                                animationIn: ["animated", "fadeIn"],
                                                animationOut: ["animated", "fadeOut"],
                                                dismiss: {
                                                    duration: 5000,
                                                    onScreen: true,
                                                    showIcon: true,
                                                    pauseOnHover: true
                                                }
                                            });
                                            if (serviceRequestId) {
                                                firebase.analytics().logEvent("media_upload", { description: "Media Uploaded", addMediaFrom: 'Service Requests' });
                                                await this.state.photoGridComponentParentCallback(serviceRequestId);
                                            } else {
                                                firebase.analytics().logEvent("media_upload", { description: "Media Uploaded", addMediaFrom: 'Inspection Reports' });
                                                await this.state.photoGridComponentParentCallback(true);
                                            }
                                            this.setState(state => ({ showAddPhotosModal: !state.showAddPhotosModal }));

                                        }
                                    }
                                }
                            >
                                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) =>
                                (<Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col xs={12}>
                                            <Form.Label>Select File (Multiple Files can be uploaded)</Form.Label>
                                        </Col>
                                        <Col xs={12}>
                                            <input id="file" name="file" type="file"
                                                // accept= {!isVideo ? `image/*` : `video/*`} capture="environment"
                                                multiple onChange={(event) => {
                                                    setFieldValue("file", event.currentTarget.files);
                                                }} />
                                            {errors.file && touched.file && <Form.Text className="text-danger">
                                                {errors.file}
                                            </Form.Text>}
                                        </Col>
                                        {/* {!identifier && <Col xs={12} className='mt-2'>
                                                    <Form.Group controlId="identifier">
                                                        <Form.Label>Identifier</Form.Label>
                                                        <Form.Control type="text" name='identifier' onChange={handleChange} />
                                                    </Form.Group>
                                                    <hr style={{ borderTop: "1px dashed rgba(0, 0, 0, 0.1)" }} />
                                                </Col>} */}
                                        <Col xs={12} className="text-right">
                                            <Button variant="secondary" className="mr-2" onClick={this.handleAddPhotosButtonClick}>
                                                Cancel
                                            </Button>
                                            <Button type="submit" variant="primary" disabled={isSubmitting}>
                                                {isSubmitting ? 'Saving...' : 'Save'}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>)
                                }
                            </Formik>
                        </Modal.Body>
                    </Modal>
                }
                {(mode === 'edit' || !mode) &&
                    <Modal backdrop="static" keyboard={false} key={'m' + 6} show={this.state.showDeletePhotoModal} onHide={this.handleDeletePhotoButtonClick}>
                        <Modal.Header closeButton>
                            <Modal.Title>Delete Photo</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p><i className="flaticon2-warning"></i> WARNING: This action is irreversible.</p>
                            <p><strong>Confirm deletion of this photo?</strong></p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.handleDeletePhotoButtonClick}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={this.handleApproveDeletePhotoButtonClick}>
                                Delete
                            </Button>
                        </Modal.Footer>
                    </Modal>
                }
            </>
        )
    }
}

export default PhotoGridComponent;
